export const SbMessageTestIds = {
  fieldMessage: 'field_message',
  unpinMessageIcon: 'unpin_message_icon',
  pinMessageIcon: 'pin_message_icon',
  fieldMessageContent: 'field_message_content',
  buttonImagecontainer: 'button_imagecontainer',
  linkDownloadfile: 'link_downloadfile',
  fieldMessageSeen: 'field_message_seen',
  fieldMessageSent: 'field_message_sent',
  fieldMessageResend: 'field_message_resend',
  fieldEdit: 'field_edit',
  buttonReaction: 'button_reaction',
  editHistoryDate: 'edit_history_date',
  completeFieldMessage: 'complete_field_message'
} as const;
